import type { TimeOff } from "../types";

// Helper to get date strings
function getDateString(daysOffset: number): string {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  return date.toISOString().split("T")[0];
}

// Mock data for useTimeOffs
export const mockTimeOffs: TimeOff[] = [
  {
    id: "timeoff_1",
    client_id: "demo_client",
    reason: "Summer Vacation",
    affected_members: { id: ["performer_1", "performer_2"] },
    start_date: getDateString(45), // In 45 days
    end_date: getDateString(59), // 2 weeks vacation
    created_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "timeoff_2",
    client_id: "demo_client",
    reason: "Professional Training",
    affected_members: { id: ["performer_1"] },
    start_date: getDateString(15), // In 15 days
    end_date: getDateString(17), // 3 days
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "timeoff_3",
    client_id: "demo_client",
    reason: "Holiday - Memorial Day",
    affected_members: { id: ["performer_1", "performer_2", "performer_3"] },
    start_date: getDateString(7), // In 7 days
    end_date: getDateString(7), // 1 day
    created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
  },
];
